import { isDocumentNode } from 'anodum';

const getScrollPositions = (element) => {
  let scrollPosition;
  if (isDocumentNode(element)) {
    scrollPosition = element.scrollingElement
      ? element.scrollingElement.scrollTop
      : element.defaultView.scrollY;
  } else {
    scrollPosition = element.scrollTop;
  }

  return scrollPosition;
};

export default getScrollPositions;
